import { createFileRoute, notFound } from '@tanstack/react-router';
import A2UIGalleryDetailPage from '@/a2ui/gallery/A2UIGalleryDetailPage';
import type { A2UIRouteData } from '@/a2ui/serverData';
import { loadA2UIRouteData } from '@/serverDataFn';

export const Route = createFileRoute('/_workbench/a2ui-gallery_/$exampleId')({
  loader: async ({ params }) => {
    const data = (await loadA2UIRouteData({ data: `/a2ui-gallery/${encodeURIComponent(params.exampleId)}` })) as A2UIRouteData;
    if (data.kind !== 'detail') throw notFound();
    return data;
  },
  component: () => {
    const data = Route.useLoaderData();
    return <A2UIGalleryDetailPage example={data.example} raw={data.raw} previewCopy={data.previewCopy} monacoSsrHtml={data.monacoSsrHtml} />;
  },
});
